<template>
  <div class="display-flex align-center justify-end justify-between-mb z-index">
    <div class="display-flex align-center justiyf-between mh1-tb f1-mb" v-for="(legend, key) in legends" :key="key">
      <img class="mr1 w3" v-if="legend.icon" :src="legend.icon" :alt="key" />
      <span v-if="key === 'systolic'">
        <span v-for="label in legend.blockLabels" :key="label.color">
          <span class="pa1 text-white" :style="`background-color: ${label.color}`">{{ label.value }}</span>
        </span>
      </span>
      <span class="ml1" v-if="legend.label !== 'AI' && legend.label !== 'Algo'">{{ legend.label }}</span>
      <span class="image-container display-flex align-center justify-center text-violet ml1" v-if="key === 'systolic' || key === 'temperature' || key === 'butane' || key === 'sulphurDioxide' || key === 'carbonDioxide'">
        <bh-tooltip
          class="f3 ma0-5 mb0-2"
          :tooltipContent="primaryModel"
          :icon="primaryModel === 'AI' ? 'ai-badge' : 'wrench'"/>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bh-legends',
  props: {
    legends: {
      type: Object | Array,
      default() {
        return []
      }
    },
    primaryModel: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.image-container {
  width: 4rem;
  height: 4rem;
  border-radius: 8px;
}
</style>
